import { excursions } from "@/mocks/excursions";
import { useSupabasePrices } from "@/hooks/useSupabasePrices";
import ExcursionCard from "@/components/feature/ExcursionCard";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useMemo } from "react";

const FEATURED_COUNT = 9;

export default function ExcursionsList() {
  const { t } = useTranslation();
  const { data: allWithPrices } = useSupabasePrices(excursions);
  const featured = useMemo(() => allWithPrices.slice(0, FEATURED_COUNT), [allWithPrices]);

  return (
    <section id="excursions" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="mb-12">
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-accent-600 font-medium mb-3">
            {t("el_badge")}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-3">
            {t("el_heading")}
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl">
            {t("el_subtitle")}
          </p>
        </div>

        {/* Cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-14">
          {featured.map((e) => (
            <ExcursionCard key={e.slug} excursion={e} />
          ))}
        </div>

        {/* Big CTA */}
        <div className="flex flex-col items-center gap-3">
          <Link
            to="/excursions"
            className="inline-flex items-center gap-3 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold text-base px-10 py-4 rounded-full transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-map-2-line text-lg"></i>
            {t("el_explore_all_btn")}
            <span className="bg-background-50/20 text-background-50 text-xs font-bold px-2.5 py-0.5 rounded-full">
              {excursions.length}
            </span>
          </Link>
          <p className="text-foreground-500 text-sm">{t("el_explore_all_sub")}</p>
        </div>
      </div>
    </section>
  );
}